<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-xl-12" v-if="loading">
          <h2>Loading...</h2>
        </div>
        <div class="col-xl-12" v-if="!loading" v-for="(customer_unit, index) in customer_unit_data">
          <h4 class="card-title">{{unit}} costs {{index}}</h4>
          <chart-card :key='customer_unit' :chart-data="customer_unit.data"
                      :chart-options="customer_unit.options"
                      :responsive-options="customer_unit.responsiveOptions"
                      chart-type="Bar"
          >
          </chart-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ChartCard from 'src/components/Cards/ChartCard.vue'
import StatsCard from 'src/components/Cards/StatsCard.vue'
import LTable from 'src/components/Table.vue'
import axios from 'axios'

import {chart_base, colors, formatMoney, formatSimple} from 'src/globalVariables'
import { setInterval } from 'timers';

Number.prototype.pad = function(size) {
  var s = String(this);
  while (s.length < (size || 2)) {s = "0" + s;}
  return s;
}

export default {
  components: {
    LTable,
    ChartCard,
    StatsCard
  },
  props: ['unit'],
  async created() {
    this.accessToken = await this.$auth.getAccessToken()
    this.loadData()
    var vm = this
    setInterval(function(){
      vm.loadData()
    },vm.refresh_minutes*60*1000)

  },
  methods: {
    loadData: function(){
      var today = new Date();
      this.last_update = today.getHours().pad(2) + ":" + today.getMinutes().pad(2) + ":" + today.getSeconds().pad(2)
      console.log('refreshing...',)
      axios
        .get('customer-units/' + this.unit + '?access_token=' + this.accessToken)
        .then(response => (this.customer_unit = response.data))
      return true
    },
    refresh_customer_unit: function() {
        chart_base.options.seriesBarWidth = 50;
        for (let vendor in this.customer_unit){
          if (Object.keys(this.customer_unit[vendor]).length > 0) {
            this.customer_unit_data[vendor] = {
              'data': {
                'labels': this.customer_unit[vendor]['date'],
                'series': [this.customer_unit[vendor]['cost']]
              },
              'options': Object.assign({}, chart_base.options),
              'responsiveOptions': Object.assign({}, chart_base.responsiveOptions),
            }
          }
        }
        this.loading = false;
    }
  },
  watch: {
    customer_unit:function(){
      this.refresh_customer_unit()
    },
    $route(to, from) {
      this.loading = true;
      this.customer_unit_data = {};
      this.loadData();
    }
  },
  computed: {

  },
  data () {
    return {
      refresh_minutes: 30,
      last_update: '',
      customer_unit:{},
      customer_unit_data: {},
      accessToken: '',
      loading: true,
    }
  }
}
</script>
<style>

</style>
